import { pm2InterfaceStore } from '@pm2/store';
import { shouldTerminateMegaMenu } from './descriptor.should-terminate-megamenu.js';
import { getNestedPages } from './util.get-nested-pages.js';

async function openMegaMenu(configStore, sitemapStore, rootDescriptor, { isMobile }) {
  pm2InterfaceStore.dispatch(
    pm2InterfaceStore.actions.setPendingMegaMenu(rootDescriptor.id)
  );
  const children = await getNestedPages(
    configStore,
    sitemapStore,
    rootDescriptor
  );
  if (!isMobile && rootDescriptor.megaMenu.displayType.levelOne === "twoColumns") {
    const firstDescriptorWithChildren = children.find(
      (it) => !shouldTerminateMegaMenu(it) && it.hasChildren
    );
    if (!firstDescriptorWithChildren) {
      pm2InterfaceStore.dispatch(
        pm2InterfaceStore.actions.openMegaMenu(rootDescriptor.id)
      );
    } else {
      await getNestedPages(
        configStore,
        sitemapStore,
        firstDescriptorWithChildren
      );
      pm2InterfaceStore.dispatch(
        pm2InterfaceStore.actions.setMegaMenu([
          rootDescriptor.id,
          firstDescriptorWithChildren.id
        ])
      );
    }
  } else {
    pm2InterfaceStore.dispatch(
      pm2InterfaceStore.actions.openMegaMenu(rootDescriptor.id)
    );
  }
}

export { openMegaMenu };
//# sourceMappingURL=megamenu.open.js.map
